/* Myscha Nuit — scripts du thème (vanilla JS, sans dépendance) */
(function () {
  'use strict';

  var cfg = window.MyschaTheme || {};

  /* ---------- Format monétaire ---------- */
  function formatMoney(cents) {
    var format = cfg.moneyFormat || 'CHF {{amount}}';
    var value = (cents / 100);
    function sep(n, thousands, decimal, decimals) {
      var parts = n.toFixed(decimals).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return parts.join(decimal);
    }
    var match = format.match(/\{\{\s*(\w+)\s*\}\}/);
    var out = '';
    switch (match ? match[1] : 'amount') {
      case 'amount_no_decimals': out = sep(value, ',', '.', 0); break;
      case 'amount_with_comma_separator': out = sep(value, '.', ',', 2); break;
      case 'amount_no_decimals_with_comma_separator': out = sep(value, '.', ',', 0); break;
      case 'amount_with_apostrophe_separator': out = sep(value, "'", '.', 2); break;
      case 'amount_no_decimals_with_space_separator': out = sep(value, ' ', '.', 0); break;
      default: out = sep(value, ',', '.', 2);
    }
    return format.replace(/\{\{\s*\w+\s*\}\}/, out);
  }

  /* ---------- Compte à rebours ---------- */
  function initCountdowns() {
    document.querySelectorAll('[data-countdown]').forEach(function (el) {
      var target = new Date(el.getAttribute('data-countdown'));
      if (isNaN(target.getTime())) return;
      function tick() {
        var diff = target.getTime() - Date.now();
        if (diff <= 0) { el.hidden = true; return false; }
        el.hidden = false;
        var d = Math.floor(diff / 86400000);
        var h = Math.floor((diff % 86400000) / 3600000);
        var m = Math.floor((diff % 3600000) / 60000);
        el.querySelector('[data-unit="days"]').textContent = String(d).padStart(2, '0');
        el.querySelector('[data-unit="hours"]').textContent = String(h).padStart(2, '0');
        el.querySelector('[data-unit="minutes"]').textContent = String(m).padStart(2, '0');
        return true;
      }
      if (tick()) {
        var timer = setInterval(function () { if (!tick()) clearInterval(timer); }, 30000);
      }
    });
  }

  /* ---------- Galerie produit ---------- */
  function showMedia(gallery, mediaId) {
    var found = false;
    gallery.querySelectorAll('[data-media-id]').forEach(function (item) {
      var match = item.getAttribute('data-media-id') === String(mediaId);
      item.hidden = !match;
      if (match) found = true;
    });
    if (!found) return;
    gallery.querySelectorAll('[data-thumb]').forEach(function (t) {
      t.setAttribute('aria-current', t.getAttribute('data-thumb') === String(mediaId) ? 'true' : 'false');
    });
    var caption = gallery.querySelector('[data-gallery-caption]');
    if (caption) caption.setAttribute('data-media', mediaId);
  }

  function initGalleries() {
    document.querySelectorAll('[data-gallery]').forEach(function (gallery) {
      gallery.querySelectorAll('[data-thumb]').forEach(function (thumb) {
        thumb.addEventListener('click', function () { showMedia(gallery, thumb.getAttribute('data-thumb')); });
      });
    });
  }

  /* ---------- Formulaire produit ---------- */
  function initProductForms() {
    document.querySelectorAll('[data-product-form]').forEach(function (form) {
      var root = form.closest('[data-product-root]') || document;
      var dataEl = root.querySelector('[data-product-json]');
      if (!dataEl) return;
      var product = JSON.parse(dataEl.textContent);
      var variants = product.variants;
      var idInput = form.querySelector('input[name="id"]');
      var submit = form.querySelector('[data-submit]');
      var submitLabel = form.querySelector('[data-submit-label]');
      var totalEl = form.querySelector('[data-total]');
      var errorEl = form.querySelector('[data-error]');
      var chain = form.querySelector('[data-chain]');
      var gallery = root.querySelector('[data-gallery]');
      var labels = {
        ready: submit ? submit.getAttribute('data-label-ready') : '',
        soldout: submit ? submit.getAttribute('data-label-soldout') : 'Épuisée',
        unavailable: submit ? submit.getAttribute('data-label-unavailable') : 'Indisponible'
      };

      function selected() {
        return product.options.map(function (_, i) {
          var checked = form.querySelector('input[name="option-' + i + '"]:checked');
          return checked ? checked.value : null;
        });
      }

      function findVariant(values) {
        return variants.find(function (v) {
          return v.options.every(function (o, i) { return o === values[i]; });
        });
      }

      function setValue(index, value) {
        var input = form.querySelector('input[name="option-' + index + '"][value="' + CSS.escape(value) + '"]');
        if (input) input.checked = true;
      }

      function markAvailability(values) {
        product.options.forEach(function (_, i) {
          form.querySelectorAll('input[name="option-' + i + '"]').forEach(function (input) {
            var test = values.slice();
            test[i] = input.value;
            var v = findVariant(test);
            var wrap = input.closest('label');
            if (wrap) wrap.classList.toggle('is-unavailable', !v || !v.available);
          });
        });
      }

      var hasOptions = form.querySelector('input[name^="option-"]') !== null;

      function update(changedIndex) {
        var values = hasOptions ? selected() : [];
        var variant = hasOptions
          ? findVariant(values)
          : (variants.find(function (v) { return String(v.id) === idInput.value; }) || variants[0]);
        if (!variant && changedIndex != null) {
          variant = variants.find(function (v) { return v.options[changedIndex] === values[changedIndex] && v.available; }) ||
                    variants.find(function (v) { return v.options[changedIndex] === values[changedIndex]; });
          if (variant) {
            variant.options.forEach(function (o, i) { setValue(i, o); });
            values = variant.options.slice();
          }
        }
        if (hasOptions) markAvailability(values);

        // Métal doré : adapte les pastilles « Poli »
        var gold = product.options.some(function (name, i) {
          return /m[ée]tal/i.test(name) && values[i] && /\bor\b/i.test(values[i]);
        });
        root.setAttribute('data-gold', gold ? 'true' : 'false');

        // Valeurs affichées (légendes, fiche de l'objet)
        values.forEach(function (val, i) {
          root.querySelectorAll('[data-bind-option="' + i + '"]').forEach(function (el) { el.textContent = val || ''; });
        });

        if (!variant) {
          if (submit) { submit.disabled = true; }
          if (submitLabel) submitLabel.textContent = labels.unavailable;
          return;
        }

        idInput.value = variant.id;
        var chainChecked = chain && chain.checked;
        var chainPrice = chainChecked ? parseInt(chain.getAttribute('data-chain-price'), 10) || 0 : 0;

        root.querySelectorAll('[data-price]').forEach(function (el) { el.textContent = formatMoney(variant.price); });
        if (totalEl) totalEl.textContent = formatMoney(variant.price + chainPrice);

        var extras = root.querySelector('[data-extras]');
        if (extras) {
          extras.textContent = chainChecked
            ? '+ ' + (extras.getAttribute('data-chain-text') || 'chaîne') + ' ' + formatMoney(chainPrice)
            : (extras.getAttribute('data-empty-text') || '');
        }

        var summary = root.querySelector('[data-summary]');
        if (summary) {
          var parts = [product.title].concat(values.filter(Boolean).map(function (v) { return v.toLowerCase(); }));
          if (chain) parts.push(chainChecked ? 'avec chaîne' : 'sans chaîne');
          summary.textContent = parts.join(' · ');
        }

        if (submit) submit.disabled = !variant.available;
        if (submitLabel) submitLabel.textContent = variant.available ? labels.ready : labels.soldout;

        if (gallery && variant.featured_media_id) showMedia(gallery, variant.featured_media_id);

        if (changedIndex != null && window.history.replaceState) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', variant.id);
          window.history.replaceState({}, '', url.toString());
        }
      }

      form.addEventListener('change', function (e) {
        var m = e.target.name && e.target.name.match(/^option-(\d+)$/);
        if (m) update(parseInt(m[1], 10));
        if (e.target === chain) update(null);
      });

      form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (errorEl) errorEl.hidden = true;
        var fd = new FormData(form);
        var main = { id: parseInt(fd.get('id'), 10), quantity: 1 };
        var plan = fd.get('selling_plan');
        if (plan) main.selling_plan = parseInt(plan, 10);
        var items = [main];
        if (chain && chain.checked) {
          var chainItem = { id: parseInt(chain.getAttribute('data-chain-variant'), 10), quantity: 1 };
          var chainPlan = chain.getAttribute('data-chain-plan');
          if (plan && chainPlan) chainItem.selling_plan = parseInt(chainPlan, 10);
          items.push(chainItem);
        }
        if (submit) submit.setAttribute('aria-busy', 'true');
        fetch(cfg.routes.cart_add_url, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: items })
        })
          .then(function (r) { return r.json().then(function (body) { return { ok: r.ok, body: body }; }); })
          .then(function (res) {
            if (!res.ok) throw new Error(res.body.description || res.body.message || 'Erreur');
            window.location.href = cfg.routes.cart_url;
          })
          .catch(function (err) {
            if (submit) submit.removeAttribute('aria-busy');
            if (errorEl) { errorEl.textContent = err.message; errorEl.hidden = false; }
          });
      });

      update(null);
    });
  }

  /* ---------- Panier : mise à jour des quantités ---------- */
  function initCart() {
    document.querySelectorAll('[data-cart-qty]').forEach(function (input) {
      input.addEventListener('change', function () { input.form.submit(); });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initCountdowns();
    initGalleries();
    initProductForms();
    initCart();
  });
})();
